import userApi from '@/apis/user'

const TimePlugin = {
  install (Vue, options) {
    let time = {
      newDate: function () {
        if (time.currentDate) {
          return time.currentDate
        } else {
          return new Date()
        }
      },
      currentDate: null,
      timeOffset: null,
      startCloudClock$i: null
    }

    let updateTimeOffset = function (dateString, latency) {
      let computerCurrentDate = new Date()
      try {
        if (dateString) {
          let cloudCurrentDate = new Date(dateString)
          cloudCurrentDate.setTime(cloudCurrentDate.getTime() + latency)
          time.timeOffset = computerCurrentDate.getTime() - cloudCurrentDate.getTime()
          Vue.logger.info('time.js: time.timeOffset: ' + time.timeOffset)
        } else {
          throw new Error('updateDate: dateString: ' + dateString + ': latency: ' + latency)
        }
      } catch (err) {
        Vue.logger.error('getting time from internet failed!')
        Vue.logger.error(err.message)
        time.timeOffset = 0
      }
    }

    let updateDate = function () {
      let timeDiffThreshold = 1000 * 1800
      let computerCurrentDate = new Date()
      try {
        if (time.timeOffset !== null) {
          let cloudCurrentDate = new Date(computerCurrentDate.getTime() - time.timeOffset)
          if (time.currentDate) {
            if (
              (cloudCurrentDate.getTime() - time.currentDate.getTime() > timeDiffThreshold) ||
              (time.currentDate.getTime() - cloudCurrentDate.getTime() > timeDiffThreshold)
            ) {
              Vue.logger.info('time.js: location.reload')
              // 0.5 hour... if time changes like 0.5 hour... reload page...
              // it is important... for everything...
              // 1. event, live time
              // 2. access token expiration... it is critical..
              location.reload()
            }
          }
          time.currentDate = cloudCurrentDate
        }
      } catch (err) {
        Vue.logger.error('time.js: updateDate failed!')
        Vue.logger.error(err.message)
        time.currentDate = computerCurrentDate
      }
    }

    let startClock = function (dateString, latency) {
      let clockTick = 1 // second
      let clockTickInterval = 1000 * clockTick // every 1 second
      updateTimeOffset(dateString, latency)
      updateDate()
      // just in case!
      if (time.startCloudClock$i) {
        clearInterval(time.startCloudClock$i)
        time.startCloudClock$i = null
      }
      // Start here
      time.startCloudClock$i = setInterval(() => {
        // console.log(time.newDate())
        updateDate()
      }, clockTickInterval)
    }

    let getTimeFromInternet = function () {
      let startTimestamp = new Date().getTime()
      userApi.pingCloud().then(
        res => {
          let endTimestamp = new Date().getTime()
          let totalLatency = (endTimestamp - startTimestamp)
          let dateString = res.headers.get('date')
          startClock(dateString, totalLatency / 2) // Client --> Server --> Client,,, so only need half latency
        },
        err => {
          let endTimestamp = new Date().getTime()
          let totalLatency = (endTimestamp - startTimestamp)
          let dateString = err.headers.get('date')
          startClock(dateString, totalLatency / 2)
        }
      )
    }

    getTimeFromInternet()

    Vue.prototype.$time = time
    Vue.time = time
  }
}

export default TimePlugin



// WEBPACK FOOTER //
// ./src/plugins/time.js